import React from 'react';

export default function ChatEnvelope() {
    return (
        <svg
            className="chat-envelope"
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="59"
            viewBox="0 0 60 59"
        >
            <g fill="none" fillRule="evenodd">
                <rect width="60" height="59" fill="#F7F7F5" />
                <path
                    fill="#2E7764"
                    d="M16.84,20.49 L16.84,40.5078571 L43.6821053,40.5078571 L43.6821053,20.49 L16.84,20.49 Z M41.0505263,22.5971429 L30.5242105,31.0257143 L19.9978947,22.5971429 L41.0505263,22.5971429 Z M18.9452632,38.4007143 L18.9452632,25.2310714 L30.2610526,34.2627026 L41.5768421,25.2310714 L41.5768421,38.4007143 L18.9452632,38.4007143 Z"
                />
            </g>
        </svg>
    );
}
